import React, { useState } from 'react';

const EC = {
  disponible: { fill: '#0055a5', hover: '#003d7a' },
  vendido: { fill: '#94a3b8', hover: '#64748b' },
  reservado: { fill: '#f97316', hover: '#ea6c0a' },
};

const INFO_105 = {
  1: { n: 1, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  2: { n: 2, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  3: { n: 3, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  4: { n: 4, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  5: { n: 5, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  6: { n: 6, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  7: { n: 7, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  8: { n: 8, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  9: { n: 9, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  10: { n: 10, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  11: { n: 11, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  12: { n: 12, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  13: { n: 13, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  14: { n: 14, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  15: { n: 15, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  16: { n: 16, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  17: { n: 17, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  18: { n: 18, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  19: { n: 19, s: 301.25, p: null,  d: 'Vista al Mar', e: 'vendido' },
  20: { n: 20, s: 301.25, p: 24000, d: 'Vista al Mar', e: 'disponible' },
  21: { n: 21, s: 301.25, p: 24000, d: 'Vista al Mar', e: 'disponible' },
  22: { n: 22, s: 301.25, p: 24000, d: 'Vista al Mar', e: 'disponible' },
  23: { n: 23, s: 562.5, p: 26500, d: 'Vista al Mar', e: 'disponible' },
  24: { n: 24, s: null, p: null,  d: 'Vista al Mar', e: 'vendido' },
  25: { n: 25, s: 373.35, p: 22000, d: 'Vista al Mar', e: 'disponible' },
  26: { n: 26, s: 356.29, p: 22000, d: 'Vista al Mar', e: 'disponible' },
  27: { n: 27, s: 360.28, p: 22000, d: 'Vista al Mar', e: 'disponible' },
  28: { n: 28, s: 360.28, p: 22000, d: 'Vista al Mar', e: 'disponible' },
  29: { n: 29, s: 360.28, p: 22000, d: 'Vista al Mar', e: 'disponible' },
  30: { n: 30, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  31: { n: 31, s: 479.77, p: 23000, d: 'Vista al Mar', e: 'disponible' },
  32: { n: 32, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  33: { n: 33, s: 360.0, p: 22000, d: 'Vista al Mar', e: 'disponible' },
  34: { n: 34, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  35: { n: 35, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  36: { n: 36, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  37: { n: 37, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  38: { n: 38, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  39: { n: 39, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  40: { n: 40, s: null, p: null, d: 'Vista al Mar', e: 'vendido' },
  41: { n: 41, s: 720.0, p: 36000, d: 'Vista al Mar', e: 'disponible' },
  42: { n: 42, s: 540.0, p: 34600, d: 'Vista al Mar', e: 'disponible' },
};

function Modal({ lote, onClose, onConsultar }) {
  React.useEffect(() => {
    const h = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);
  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{
        backgroundColor: 'rgba(0,0,0,0.6)',
        backdropFilter: 'blur(6px)',
      }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden"
        style={{ animation: 'popIn 0.28s cubic-bezier(0.34,1.56,0.64,1) both' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-[#0055a5] px-7 py-5 text-white relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-2xl font-bold opacity-50 hover:opacity-100"
          >
            x
          </button>
          <p className="text-[10px] uppercase tracking-[0.3em] opacity-60 mb-1">
            Manzana 105
          </p>
          <h3 className="text-3xl font-black">Parcela {lote.n}</h3>
          <span className="inline-block mt-2 text-[10px] font-black uppercase px-3 py-1 rounded-full bg-white/20">
            {lote.e === 'disponible'
              ? 'Disponible'
              : lote.e === 'reservado'
              ? 'Reservado'
              : 'Vendido'}
          </span>
        </div>
        <div className="p-5 grid grid-cols-2 gap-3">
          <div className="bg-slate-50 rounded-2xl p-4">
            <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1">
              Superficie
            </p>
            <p className="text-2xl font-black text-slate-800">
              {lote.s ? `${lote.s}` : '-'}
              <span className="text-sm font-normal text-slate-400"> m²</span>
            </p>
          </div>
          <div className="bg-slate-50 rounded-2xl p-4">
            <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1">
              Precio
            </p>
            <p
              className="text-xl font-black"
              style={{ color: lote.e === 'disponible' ? '#0055a5' : '#94a3b8' }}
            >
              {lote.e === 'disponible' && lote.p ? (
                'USD ' + lote.p.toLocaleString()
              ) : (
                <span className="text-base">-</span>
              )}
            </p>
          </div>
          <div className="bg-slate-50 rounded-2xl p-4 col-span-2">
            <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1">
              Ubicación
            </p>
            <p className="text-base font-semibold text-slate-700">{lote.d}</p>
          </div>
        </div>
        <div className="px-5 pb-5">
          {lote.e === 'disponible' ? (
            <button
              onClick={onConsultar}
              className="w-full bg-[#0055a5] text-white py-4 rounded-2xl font-black uppercase tracking-widest text-sm hover:bg-blue-700 active:scale-95 transition-all"
            >
              Consultar este lote
            </button>
          ) : (
            <p className="text-center text-slate-400 text-sm py-2">
              {lote.e === 'vendido'
                ? 'Este lote fue vendido.'
                : 'Este lote está reservado.'}
            </p>
          )}
        </div>
      </div>
      <style>
        {
          '@keyframes popIn{from{opacity:0;transform:scale(0.8) translateY(20px)}to{opacity:1;transform:scale(1) translateY(0)}}'
        }
      </style>
    </div>
  );
}

function getCentroid105(pts) {
  const coords = pts.trim().replace(/,/g, ' ').split(/\s+/).map(Number).filter(n => !isNaN(n));
  let x = 0, y = 0;
  const count = coords.length / 2;
  for (let i = 0; i < coords.length; i += 2) { x += coords[i]; y += coords[i+1]; }
  return [x / count, y / count];
}

function Parcel({ id, points, d, num, hov, setHov, onClick }) {
  const lote = INFO_105[num];
  if (!lote) return null;
  const estado = lote.e;
  const fill = hov === id ? EC[estado].hover : EC[estado].fill;
  const isClickable = estado !== 'vendido';
  const shapeProps = {
    id, fill, stroke: 'white', strokeWidth: 2,
    style: isClickable ? { cursor: 'pointer' } : {},
    onMouseEnter: isClickable ? () => setHov(id) : undefined,
    onMouseLeave: isClickable ? () => setHov(null) : undefined,
    onClick: isClickable ? () => onClick(lote) : undefined,
  };
  if (points) return <polygon {...shapeProps} points={points} />;
  if (d) return <path {...shapeProps} d={d} fill={fill} />;
  return null;
}

export default function Manzana105SVG() {
  const [hov, setHov] = useState(null);
  const [modal, setModal] = useState(null);

  const handleConsultar = () => {
    if (modal) {
      window.dispatchEvent(
        new CustomEvent('seleccionarLote', {
          detail: { manzana: '105', lote: modal.n },
        })
      );
    }
    setModal(null);
    setTimeout(
      () =>
        document
          .getElementById('contacto')
          ?.scrollIntoView({ behavior: 'smooth' }),
      150
    );
  };
  const disp = Object.values(INFO_105).filter(l=>l.e==='disponible').length;
  const res = Object.values(INFO_105).filter(
    (l) => l.e === 'reservado'
  ).length;
  const vend = Object.values(INFO_105).filter((l) => l.e === 'vendido').length;

  return (
    <div>
      <div className="mb-4">
        <div className="flex flex-wrap items-center gap-3 mb-1">
          <h3 className="text-lg font-black text-[#0055a5] uppercase tracking-wide">
            Manzana 105 - Río y Mar
          </h3>
          <span className="text-xs font-bold px-3 py-1 rounded-full bg-blue-50 text-[#0055a5]">
            {disp} disponibles
          </span>
          {res > 0 && (
            <span className="text-xs font-bold px-3 py-1 rounded-full bg-orange-50 text-orange-500">
              {res} reservados
            </span>
          )}
          <span className="text-xs font-bold px-3 py-1 rounded-full bg-slate-100 text-slate-500">
            {vend} vendidos
          </span>
        </div>
        <p className="text-sm text-slate-400">
          Hacé click en cualquier lote para ver los detalles.
        </p>
      </div>
      <div className="flex flex-wrap gap-4 mb-4">
        {[
          ['disponible', '#0055a5'],
          ['reservado', '#f97316'],
          ['vendido', '#94a3b8'],
        ].map(([k, c]) => (
          <div key={k} className="flex items-center gap-2">
            <span
              className="w-3.5 h-3.5 rounded-sm"
              style={{ backgroundColor: c, display: 'inline-block' }}
            />
            <span className="text-xs font-semibold text-slate-500 capitalize">
              {k}
            </span>
          </div>
        ))}
      </div>
      <div className="bg-[#f8fafc] rounded-2xl border border-stone-100 overflow-hidden p-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 650 900"
          className="w-full h-auto"
          style={{ maxHeight: 580 }}
        >
          {/* Coordenadas corregidas: offset aplicado dx=+926.95 dy=-162.10 */}
          <Parcel
            id="105-1"
            num={1}
            points="297.36,80.00 284.95,80.00 199.41,166.02 231.19,197.28 322.86,105.08 297.36,80.00"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-2"
            num={2}
            points="355.19,136.92 263.52,229.12 231.74,197.87 323.42,105.67 355.19,136.92"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-3"
            num={3}
            points="386.12,166.80 294.45,259.00 264.08,229.71 355.75,137.51 386.12,166.80"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-4"
            num={4}
            points="414.47,195.81 298.05,312.88 269.46,283.98 385.88,166.91 414.47,195.81"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-5"
            num={5}
            points="444.31,228.59 340.46,330.38 310.08,301.09 415.48,196.26 444.31,228.59"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-6"
            num={6}
            points="476.64,259.94 372.79,361.74 340.46,330.38 444.31,228.59 476.64,259.94"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-7"
            num={7}
            points="509.95,292.27 406.10,394.07 373.77,362.72 477.62,260.92 509.95,292.27"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-8"
            num={8}
            points="519.79,341.79 437.00,427.52 406.10,393.58 509.95,292.27 519.79,341.79"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-9"
            num={9}
            points="514.40,411.35 467.37,458.87 437.45,426.89 519.70,342.54 514.40,411.35"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-10"
            num={10}
            points="534.49,455.93 484.03,504.43 453.62,472.94 514.85,411.80 534.49,455.93"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-11"
            num={11}
            points="435.04,553.91 534.49,455.93 551.14,499.04 463.46,585.75 435.04,553.91"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-12"
            num={12}
            points="571.72,543.62 495.30,617.10 463.46,585.75 551.14,499.04 571.72,543.62"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-13"
            num={13}
            points="574.66,599.96 499.71,675.40 466.88,644.53 571.72,543.62 574.66,599.96"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-14"
            num={14}
            d="M504.61,730.75l-32.82-29.88,102.87-100.91,5.82,24.63c.36,1.54.58,3.11.64,4.69l.33,8.20c.04,1.11.01,2.22-.09,3.33l-.53,5.61c-.19,2-.63,3.98-1.30,5.87l-1.93,5.47h0c-1.29,3.86-3.51,7.34-6.46,10.13l-66.53,62.86Z"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-15"
            num={15}
            points="429.65,657.76 504.61,730.75 477.66,757.70 403.20,684.70 429.65,657.76"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-16"
            num={16}
            points="453.17,781.70 477.66,757.70 403.20,684.70 382.14,710.18 453.17,781.70"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-17"
            num={17}
            points="438.47,798.36 453.17,781.70 382.14,710.18 357.15,737.61 414.96,796.40 438.47,798.36"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-18"
            num={18}
            d="M378.89,804.72l-48.68-45.56,29.42-21.55,63.13,58.79-1.71.07c-14.46.60-28.70,3.39-42.16,8.26h0Z"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-19"
            num={19}
            points="304.74,684.21 357.15,737.61 330.21,759.17 288.08,719.49 287.59,700.38 304.74,684.21"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-20"
            num={20}
            points="329.39,658.35 382.14,710.18 357.15,737.61 304.74,684.21 329.39,658.35"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-21"
            num={21}
            points="353.26,633.42 403.20,684.70 382.14,710.18 329.39,658.35 353.26,633.42"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-22"
            num={22}
            points="378.73,610.07 429.65,657.76 403.20,684.70 353.26,633.42 378.73,610.07"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-23"
            num={23}
            points="404.72,585.67 497.03,673.21 473.16,696.55 378.73,610.07 404.72,585.67"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-24"
            num={24}
            points="415.86,553.84 435.04,553.91 463.46,585.75 493.85,615.38 466.88,644.53 404.72,585.67 415.33,574.00 415.86,553.84"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-25"
            num={25}
            points="415.86,553.84 416.39,532.09 405.78,519.88 453.62,472.94 484.03,504.43 435.04,553.91 415.86,553.84"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-26"
            num={26}
            points="465.20,458.87 404.72,518.82 380.32,496.01 442.39,432.88 465.20,458.87"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-27"
            num={27}
            points="442.39,432.88 379.38,495.42 354.83,469.49 417.98,407.94 442.39,432.88"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-28"
            num={28}
            points="417.21,409.21 354.83,469.49 330.42,444.66 392.80,384.27 417.21,409.21"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-29"
            num={29}
            points="392.02,386.04 330.15,444.81 305.74,421.99 367.62,361.10 392.02,386.04"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-30"
            num={30}
            points="367.62,361.10 306.98,422.65 278.78,394.95 342.44,332.90 367.62,361.10"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-31"
            num={31}
            points="310.08,301.09 342.44,332.90 278.78,394.95 269.90,385.57 247.11,385.57 248.08,361.81 310.08,301.09"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-32"
            num={32}
            points="152.57,335.63 215.30,398.38 228.69,385.57 247.11,385.57 248.08,363.75 184.57,303.63 152.57,335.63"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-33"
            num={33}
            points="126.12,361.10 152.57,335.63 215.30,398.38 189.34,422.87 126.12,361.10"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-34"
            num={34}
            points="101.93,387.35 128.38,361.88 189.12,422.62 163.16,447.11 101.93,387.35"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-35"
            num={35}
            points="99.97,386.86 163.16,447.11 149.44,462.79 132.79,462.79 78.90,407.43 99.97,386.86"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-36"
            num={36}
            d="M50.00,314.85l-.79.79c3,7.92,4.71,16.99,4.71,26.64,0,11.78-2.55,22.69-6.89,31.70l31.87,33.45,30.37-30.37-59.28-62.21Z"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-37"
            num={37}
            points="109.27,377.06 50.00,314.85 71.13,293.45 130.40,355.67 109.27,377.06"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-38"
            num={38}
            points="130.98,355.28 71.35,293.22 96.34,268.24 155.97,330.30 130.98,355.28"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-39"
            num={39}
            points="157.65,328.62 96.56,268.50 121.55,243.52 182.63,303.63 157.65,328.62"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-40"
            num={40}
            points="248.08,363.75 123.23,241.83 148.21,216.85 273.07,338.77 248.08,363.75"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-41"
            num={41}
            points="272.81,339.02 147.95,217.11 172.94,192.13 297.79,314.04 272.81,339.02"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
          <Parcel
            id="105-42"
            num={42}
            points="267.70,283.04 173.16,191.90 198.15,166.92 292.69,258.06 267.70,283.04"
            hov={hov}
            setHov={setHov}
            onClick={setModal}
          />
        </svg>
      </div>
      {modal && (
        <Modal
          lote={modal}
          onClose={() => setModal(null)}
          onConsultar={handleConsultar}
        />
      )}
    </div>
  );
}
